<template>
  <div>
    <v-row class="mt-3">
      <v-col class="" cols="auto">
        <div class="tertiary--text text-body-2">
          {{ labels.name() }}
        </div>
        <v-text-field
          color="tertiary"
          v-model.trim="personalDataForm.personFirstName"
          @blur="checkName; changeDataForm"
          :counter="25"
          dense
          filled
          :rules="[rules.required, rules.length, rules.valid]"
          ref="personFirstName"
          id="idPersonasNombre"
        ></v-text-field>
      </v-col>
      <v-col class="" cols="auto">
        <div class="tertiary--text text-body-2">
          {{ labels.lastName() }}
        </div>
        <v-text-field
          color="tertiary"
          v-model.trim="personalDataForm.personLastName"
          @blur="checkName; changeDataForm"
          :counter="25"
          dense
          filled
          :rules="[rules.required, rules.length, rules.valid]"
          ref="personLastName"
          id="idPersonasApellido"
        ></v-text-field>
      </v-col>
      <v-col cols="auto">
        <slot></slot>
      </v-col>
    </v-row>
    <v-row class="mb-3">
      <v-col cols="12" sm="12" md="4" lg="3" xl="2">
        <div class="tertiary--text text-body-2">
          {{ labels.identityType() }}
        </div>
        <v-select
          :id="selectIdByTypeDocument"
          :items="identificationType"
          v-model.trim="personalDataForm.personIdentificationType"
          :rules="[rules.contactIdentificationType]"
          :error="personalDataForm.showMessageTypeInput"
          :error-messages="personalDataForm.identificationTypeIsRequiredMessage"
          clearable
          filled
          dense
          color="tertiary"
          ref="personIdentificationType"
          @change="changeDataForm"
        ></v-select>
      </v-col>
      <v-col cols="12" sm="12" md="4" lg="3" xl="2">
        <div class="tertiary--text text-body-2">
          {{ labels.numberIdentity() }}
        </div>
        <v-text-field
          id="idPersonasNumeroDocumento"
          type="number"
          v-model.trim="personalDataForm.personIdentificationNumber"
          :rules="[rules.contactIdNumber, rules.identificationNumberLen]"
          :error="
            personDuplicated ||
              personalDataForm.showMessageNumberInput
          "
          :error-messages="
            personalDataForm.errorMessage ||
              personalDataForm.idNumberIsRequiredMessage
          "
          @keydown="testFilter($event)"
          :hint="noDotsCommasOrDashes"
          filled
          dense
          :prefix="onPrefixTextField"
          color="tertiary"
          ref="personIdentificationNumber"
          @input="changeDataForm"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { i18n } from '@leapsight/portal'
import PersonsHelpers from '@/helpers/persons/personsHelpers.js'
import { mapGetters } from 'vuex'
export default {
  name: 'PersonalDataInput',
  emits: ['personalDataDialogEmit'],
  props: {
    isNewPersonView: {
      type: Boolean,
      default() {
        return false
      }
    },
    hasRoleContactEmergency: {
      type: Boolean,
      default() {
        return true
      }
    },
    personalDataProp: {
      type: Object,
      default() {
        return {
          personFirstName: '',
          personLastName: '',
          person: {},
          personIdentificationType: '',
          personIdentificationNumber: '',
          errorMessage: '',
          idNumberIsRequiredMessage: '',
          identificationTypeIsRequiredMessage: '',
          showMessageTypeInput: false,
          showMessageNumberInput: false
        }
      }
    }
  },
  data() {
    return {
      personalDataForm: {},
      personDuplicated: false,
      identification_number: '',
      identification_type: '',
      identificationTypeIsRequiredMessage: '',
      identificationType: ['DNI', 'RUT', 'CI'],
      rules: {
        required: v =>
          !!v || i18n.t('fleet_management.persons.person_info.rules.required'),
        length: v =>
          (v && v.length <= 25 && v.length >= 2) ||
          i18n.t('fleet_management.persons.person_info.rules.character_length'),
        valid: v =>
          /[\w+À-ÿñÑ\s]{0,25}([^@;,])$/gi.test(v) ||
          i18n.t('fleet_management.agents.create.errors.invalid_name'),
        contactIdNumber: v =>
          this.hasRoleContactEmergency
            ? !!v ||
              i18n.t(
                'fleet_management.persons.new_person.rules.id_number_required'
              )
            : true,
        identificationNumberLen: v =>
          Boolean(this.personDataIdentificationType)
            ? (this.personalDataForm.personIdentificationType == 'DNI'
                ? v.length > 6 && v.length < 9
                : this.personalDataForm.personIdentificationType == 'RUT'
                ? v.length > 7 && v.length < 12
                : this.personalDataForm.personIdentificationType == 'CI'
                ? v.length > 5 && v.length < 9
                : false) ||
              i18n.t(
                'fleet_management.persons.new_person.rules.identification_number_len'
              )
            : true,
        contactIdentificationType: v =>
          this.hasRoleContactEmergency
            ? !!v ||
              i18n.t(
                'fleet_management.persons.new_person.rules.select_required'
              )
            : true
      },
      labels: {
        name: () =>
          this.isNewPersonView
          ? i18n.t(
              'fleet_management.persons.new_person.labels.card_field_name'
            )
          : i18n.t(
              'fleet_management.persons.person_info.labels.card_field_name'
            ),
        lastName: () =>
          this.isNewPersonView
          ? i18n.t(
              'fleet_management.persons.new_person.labels.card_field_lastname'
            )
          : i18n.t(
              'fleet_management.persons.person_info.labels.card_field_lastname'
            ),
        identityType: () =>
          this.hasRoleContactEmergency
            ? i18n.t(
                'fleet_management.persons.new_person.labels.card_field_identification_type'
              )
            : i18n.t(
                'fleet_management.persons.new_person.labels.card_field_identification_type_optional'
              ),
        numberIdentity: () =>
          this.hasRoleContactEmergency
            ? i18n.t(
                'fleet_management.persons.new_person.labels.card_field_number'
              )
            : i18n.t(
                'fleet_management.persons.new_person.labels.card_field_number_optional'
              )
      }
    }
  },
  created() {
    this.personalDataForm = structuredClone(
      this.formatData(this.personalDataProp)
    )
  },
  computed: {
    ...mapGetters('persons', ['getCurrentPerson']),
    selectIdByTypeDocument() {
      switch (this.personalDataForm.personIdentificationType) {
        case 'DNI':
          return 'idPersonasDni'
        case 'RUT':
          return 'idPersonasRut'
        case 'CI':
          return 'idPersonasCi'
        default:
          return 'idPersonasTipoDocumento'
      }
    },
    noDotsCommasOrDashes() {
      return i18n.t(
        'fleet_management.persons.new_person.rules.usage_dots_commas'
      )
    },
    onPrefixTextField() {
      return this.personalDataForm.personIdentificationType == 'DNI' &&
        this.personalDataForm.personIdentificationNumber?.length < 8
        ? '0'
        : null
    },
    personDataIdentificationType() {
      return this.personalDataForm.personIdentificationType
    },
    getErrorMessage() {
      return this.personalDataProp.errorMessage
    },
    getIdNumberIsRequiredMessage() {
      return this.personalDataProp.idNumberIsRequiredMessage
    },
    getShowMessageIdForContactEmergency() {
      return this.personalDataProp.showMessageTypeInput
    },
    getIdentificationTypeIsRequiredMessage() {
      return this.personalDataProp.identificationTypeIsRequiredMessage
    },
    getShowMessageNumberForContactEmergency() {
      return this.personalDataProp.showMessageNumberInput
    }
  },
  watch: {
    getErrorMessage(value) {
      this.personalDataForm.errorMessage = value
    },
    getIdNumberIsRequiredMessage(value) {
      this.personalDataForm.idNumberIsRequiredMessage = value
    },
    getShowMessageIdForContactEmergency(value) {
      this.personalDataForm.showMessageTypeInput = value
    },
    getIdentificationTypeIsRequiredMessage(value) {
      this.personalDataForm.identificationTypeIsRequiredMessage = value
    },
    getShowMessageNumberForContactEmergency(value) {
      this.personalDataForm.showMessageNumberInput = value
    }
  },
  updated() {
    this.throwPersonalDataEdit()
  },
  methods: {
    changeDataForm() {
    const isBasicFormValid = this.$refs.personFirstName.validate() &&
                            this.$refs.personLastName.validate()

    const requiresIdentification = this.hasRoleContactEmergency

    const isIdentificationValid = requiresIdentification
      ? (this.$refs.personIdentificationType.validate() &&
        this.$refs.personIdentificationNumber.validate())
      : true

    const isFormValid = isBasicFormValid && isIdentificationValid

    this.$emit('validationStatus', isFormValid)
    },
    formatData(dataProp) {
      if (Boolean(dataProp.personIdentificationNumber)) {
        dataProp.personIdentificationNumber = dataProp.personIdentificationNumber.split(
          '-'
        )[0]
      }
      return dataProp
    },
    throwPersonalDataEdit() {
      this.$emit('personalDataEditEmit', this.personalDataForm)
    },
    checkName() {
      const name = this.personalDataForm.personFirstName
      const lastName = this.personalDataForm.personLastName
      const id = this.personalDataForm.person.id
      if (name !== '' && lastName !== '') {
        const persons = this.$store.state.persons.filterPersons
        for (let index = 0; index < persons.length; index++) {
          const element = persons[index]
          if (
            (this.getCurrentPerson.first_name !== name ||
            this.getCurrentPerson.last_name !== lastName) &&
            element.first_name === name &&
            element.last_name === lastName &&
            element.id !== id
          ) {
            this.$emit('personalDataDialogEmit', {
              repeatPersons: element,
              dialogName: true
            })
            break
          }
        }
      }
    },
    testFilter(e) {
      const key = e.keyCode
      if (
        (48 > key || key > 58) &&
        (96 > key || key > 105) &&
        (37 > key || key > 40) &&
        key != 8 &&
        key != 13
      )
        e.preventDefault()
      else this.personalDataForm.personIdentificationNumber = e.target.value
    }
  }
}
</script>

<style scoped></style>
